// Enum-like object for user roles in the application
export const Roles = {
  SUPER: 'super', // Super user role
  ADMIN: 'admin', // Admin role
  USER: 'user', // Regular user role
  UNKNOWN: '', // Unknown or unset role
} as const;

// Type representing possible role values
export type Roles = (typeof Roles)[keyof typeof Roles];

// Enum-like object for environment types
export const RolesEnv = {
  PROD: 'prod', // Production environment
  TEST: 'test', // Test environment
} as const;

// Type representing possible environment values
export type RolesEnv = (typeof RolesEnv)[keyof typeof RolesEnv];
